import type { LocaleContent } from "@/types/site";

export const LOCALES = ["en", "es"] as const;

export type LocaleCode = (typeof LOCALES)[number];

export const DEFAULT_LOCALE: LocaleCode = "en";

export function isLocale(value: unknown): value is LocaleCode {
  return (
    typeof value === "string" && (LOCALES as readonly string[]).includes(value)
  );
}

export interface Messages {
  actions: {
    backToHome: string;
    call: string;
    closeMenu: string;
    consultation: string;
    copyLink: string;
    copyLinkSuccess: string;
    email: string;
    openMenu: string;
    share: string;
    switchLanguage: string;
    tryAgain: string;
  };
  admin: {
    emailPlaceholder: string;
    emptyDescription: string;
    emptyTitle: string;
    eyebrow: string;
    eventTypeLabel: string;
    filterAllStatuses: string;
    filterStatusLabel: string;
    inquiriesDescription: string;
    inquiriesLoadError: string;
    inquiriesLoading: string;
    inquiriesTitle: string;
    inquiryDetailsTitle: string;
    inquiryListTitle: string;
    inquiryListSupport: string;
    loginButton: string;
    loginDescription: string;
    loginError: string;
    loginPending: string;
    loginTitle: string;
    statusArchived: string;
    statusInProgress: string;
    statusLabel: string;
    statusNew: string;
    statusSaveError: string;
    statusSavePending: string;
    statusSaveSuccess: string;
    logoutButton: string;
    passwordLabel: string;
    passwordPlaceholder: string;
    receivedAtLabel: string;
  };
  common: {
    address: string;
    description: string;
    email: string;
    loading: string;
    mobileNavigation: string;
    name: string;
    optional: string;
    phone: string;
    primaryNavigation: string;
    required: string;
    skipToContent: string;
    toggleNav: string;
  };
  consent: {
    accept: string;
    decline: string;
    description: string;
    learnMore: string;
    title: string;
  };
  errors: {
    boundaryEyebrow: string;
    boundaryHint: string;
    boundaryTitle: string;
    notFoundIntro: string;
    notFoundSeoTitle: string;
    notFoundTitle: string;
    unknownLocale: string;
  };
  footer: {
    apoloLogoAlt: string;
    credit: string;
    follow: string;
  };
  localeSwitcher: {
    englishLabel: string;
    spanishLabel: string;
  };
  share: {
    email: string;
    linkedin: string;
    native: string;
    twitter: string;
  };
  sitemap: {
    jumpToSection: string;
  };
  content: LocaleContent;
}
